(function () {

  const SHOPIFY_CHAT_SELECTOR = 'shopify-chat';

  const PREMIUM_CSS = `
    /* =========================================
       SHOPIFY INBOX - PREMIUM BLACK & GOLD
       ========================================= */

    #shopify-element-wrapper {
      position: relative !important;
    }

    /* =========================================
       FLOATING CHAT BUTTON POSITION
       ========================================= */

    .activator-nudge.activator-nudge--right {
      right: 24px !important;
      left: auto !important;
      bottom: 95px !important;
      margin: 0 !important;
      z-index: 999999 !important;
    }

    /* =========================================
       CHAT BUTTON
       ========================================= */

    button[part="activator"],
    button.activator {
      width: 58px !important;
      height: 58px !important;

      min-width: 58px !important;
      min-height: 58px !important;

      padding: 0 !important;
      margin: 0 !important;

      border-radius: 50% !important;

      background: #111111 !important;
      color: #C9A227 !important;

      border: 1px solid #C9A227 !important;

      box-shadow:
        0 8px 25px rgba(0, 0, 0, 0.28),
        0 0 0 1px rgba(201, 162, 39, 0.12) !important;

      transition:
        transform 0.25s ease,
        box-shadow 0.25s ease,
        background 0.25s ease !important;

      cursor: pointer !important;
    }

    /* =========================================
       BUTTON HOVER
       ========================================= */

    button[part="activator"]:hover,
    button.activator:hover {
      background: #000000 !important;
      color: #D4AF37 !important;

      transform: translateY(-2px) !important;

      box-shadow:
        0 12px 30px rgba(0, 0, 0, 0.35),
        0 0 0 1px rgba(201, 162, 39, 0.35),
        0 0 18px rgba(201, 162, 39, 0.12) !important;
    }

    /* =========================================
       BUTTON ACTIVE
       ========================================= */

    button[part="activator"]:active,
    button.activator:active {
      transform: scale(0.96) !important;
    }

    /* =========================================
       CHAT ICON
       ========================================= */

    button[part="activator"] svg,
    button.activator svg {
      width: 24px !important;
      height: 24px !important;

      color: #C9A227 !important;
      fill: none !important;
      stroke: currentColor !important;
    }

    /* =========================================
       FOCUS
       ========================================= */

    button[part="activator"]:focus-visible {
      outline: 2px solid #C9A227 !important;
      outline-offset: 4px !important;
    }

    /* =========================================
       MOBILE
       ========================================= */

    @media (max-width: 767px) {

      .activator-nudge.activator-nudge--right {
        right: 16px !important;
        bottom: 180px !important;
      }

      button[part="activator"],
      button.activator  {
        width: 52px !important;
        height: 52px !important;

        min-width: 52px !important;
        min-height: 52px !important;

        border-radius: 50% !important;
      }

      button[part="activator"] svg,
      button.activator svg {
        width: 22px !important;
        height: 22px !important;
      }
    }
  `;


  function injectShopifyInboxStyles() {

    const chat = document.querySelector(SHOPIFY_CHAT_SELECTOR);

    if (!chat || !chat.shadowRoot) {
      return false;
    }

    const shadowRoot = chat.shadowRoot;

    if (shadowRoot.querySelector('#deepanshi-premium-inbox-style')) {
      return true;
    }

    const style = document.createElement('style');

    style.id = 'deepanshi-premium-inbox-style';

    style.textContent = PREMIUM_CSS;

    shadowRoot.appendChild(style);

    return true;
  }


  function startShopifyInboxStyling() {

    injectShopifyInboxStyles();

    let attempts = 0;

    const interval = setInterval(function () {

      injectShopifyInboxStyles();

      attempts++;

      if (attempts >= 40) {
        clearInterval(interval);
      }

    }, 500);


    const observer = new MutationObserver(function () {

      injectShopifyInboxStyles();

    });


    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      startShopifyInboxStyling
    );

  } else {

    startShopifyInboxStyling();

  }

})();



